import { render, staticRenderFns } from "./PrototypeShell.vue?vue&type=template&id=50efac93&scoped=true"
import script from "./PrototypeShell.vue?vue&type=script&lang=js"
export * from "./PrototypeShell.vue?vue&type=script&lang=js"
import style0 from "./prototype/style.css?vue&type=style&index=0&id=50efac93&prod&scoped=true&lang=css&external"
import style1 from "./prototype/slots-design.css?vue&type=style&index=1&id=50efac93&prod&scoped=true&lang=css&external"
import style2 from "./prototype/hrms-match.css?vue&type=style&index=2&id=50efac93&prod&scoped=true&lang=css&external"
import style3 from "./PrototypeShell.vue?vue&type=style&index=3&id=50efac93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_cache-loader@4.1.0_webpack@4.47.0_supports-_b570ce719d351ec75185e9a1f4df1242/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50efac93",
  null
  
)

export default component.exports